import React, { useState } from "react";
import Plot from "react-plotly.js";

import { AddFilterBaseFunc, chartAttrs, defaultConfig, defaultStyles, graphColors, IFilterKeys, IFilters, RemoveFilterBaseFunc } from "models/core";
import { AddFilterFunc, RemoveFilterFunc, DashboardFilterKeys } from "models/mdt";
import { DiagnosesByService, PatientsByService, ReviewsByService } from "models/mdt/plotdata";
import { PlotData, PlotType } from "plotly.js";
import { Dialog } from "@mui/material";
import { LabelSharp } from "@mui/icons-material";
import { addFilterFactory } from "helpers/filterHelper";
import { HierarchyBreadcrumb } from "components/common/HierarchyBreadcrumb";
import { DashTable } from "components/common/DashTable";
import { DashChart } from "components/common/DashChart";
import { ChartIcons } from "components/common/ChartIcons";
import { SimpleBreadcrumb } from "components/common/SimpleBreadcrumb";
import { chartDimesionsCalc, ChartOrientation, ChartType, QoolDashChart } from "../core";
import watermark from "../../static/qca-black.png";
import { truncateStringWithEllipsis } from "helpers/stringHelper";
import { CreateChart } from "components/common/CreateChart";
import { HHSLabel } from "config/appUrlConfig";

interface IProps {
	plotDataReviews: ReviewsByService.IPlotData;
	plotDataPatients: PatientsByService.IPlotData;
	plotDataDiagnoses: DiagnosesByService.IPlotData;
	activeFilters: IFilters<IFilterKeys>;
	//addFilterFn: (e: any, filterKey: string, getY: (p) => string) => void;
	addFilterFn: AddFilterBaseFunc<typeof DashboardFilterKeys>;
	removeFilterFn: RemoveFilterBaseFunc<typeof DashboardFilterKeys>;
}

/**
 * Reviews by service chart / My MDTs
 */
export function ReviewsByServiceChart(props: IProps) {

	const { plotDataReviews, plotDataPatients, plotDataDiagnoses, activeFilters, addFilterFn, removeFilterFn } = props;
	const hierarchy = plotDataReviews;

	let valuesROriginal = [];
	let labelsROriginal = [];
	let valuesPOriginal = [];
	let labelsPOriginal = [];
	let valuesDOriginal = [];
	let labelsDOriginal = [];

	let valuesRReversed = [];
	let labelsRReversed = [];
	let valuesPReversed = [];
	let labelsPReversed = [];
	let valuesDReversed = [];
	let labelsDReversed = [];

	let Reviews = {};
	let Patients = {};
	let Diagnoses = {};


	valuesROriginal = hierarchy.values;
	labelsROriginal = hierarchy.labels;
	valuesRReversed = hierarchy.values.slice().reverse();
	labelsRReversed = hierarchy.labels.slice().reverse();
	Reviews = { "name": "Presentations", "labels": labelsROriginal, "labelsReversed": labelsRReversed, "values": valuesROriginal, "valuesReversed": valuesRReversed };

	valuesPOriginal = plotDataPatients.values;
	labelsPOriginal = plotDataPatients.labels;
	valuesPReversed = plotDataPatients.values.slice().reverse();
	labelsPReversed = plotDataPatients.labels.slice().reverse();
	Patients = { "name": "Patients", "labels": labelsPOriginal, "labelsReversed": labelsPReversed, "values": valuesPOriginal, "valuesReversed": valuesPReversed };

	valuesDOriginal = plotDataDiagnoses.values;
	labelsDOriginal = plotDataDiagnoses.labels;
	valuesDReversed = plotDataDiagnoses.values.slice().reverse();
	labelsDReversed = plotDataDiagnoses.labels.slice().reverse();
	Diagnoses = { "name": "Diagnoses", "labels": labelsDOriginal, "labelsReversed": labelsDReversed, "values": valuesDOriginal, "valuesReversed": valuesDReversed };

	const tracesArray: any[] = [];

	tracesArray.push(Patients);
	tracesArray.push(Diagnoses);
	tracesArray.push(Reviews);	

	const legend = (chartType: ChartType) => {
		if (chartType == ChartType.Table)
			return null;

		return (
			<div className="dash-legend">
				<div>
					<div className="key" style={{ backgroundColor: graphColors.default[0] }}></div>
					<div className="title">Patients</div>
				</div>
				<div>
					<div className="key" style={{ backgroundColor: graphColors.default[1] }}></div>
					<div className="title">Diagnoses</div>
				</div>
				<div>
					<div className="key" style={{ backgroundColor: graphColors.default[2] }}></div>
					<div className="title">Presentations</div>
				</div>
			</div>
		)
	}

	//Text for info icon on hover
	const toolTipText = ["Patients:", "A unique count of a patient presented to a MDT",
		"Diagnoses:", "A unique count of a patient's diagnoses presented to a MDT",
		"Presentations:", "A count of patient presentations to MDT where a patient can present multiple times",
		"", "Records excluded from analysis are those in which a diagnosis has not been selected at time of referral"
	];


	return (
		<QoolDashChart
			xAxis={{ horizontalOrientation: { label: "" }, verticalOrientation: { label: "" } }}
			yAxis={{ horizontalOrientation: { label: "" }, verticalOrientation: { label: "" } }}
			chartOrder={{ horizontalOrientation: { reversed: false }, verticalOrientation: { reversed: true } }}
			defaultChartOrientation={ChartOrientation.Horizontal}
			defaultChartType={ChartType.Bar}
			chartTitle="My MDT(s)"
			filterKey={DashboardFilterKeys.Mdt.key}
			plotData={tracesArray}
			activeFilters={props.activeFilters}
			addFilterFn={props.addFilterFn}
			removeFilterFn={props.removeFilterFn}
			hoverText="%{fullData.name}"
			chartIcons={{
				line: false,
				pie: false,
				help: toolTipText
			}}
			chartDimensions={{
				chartHeightProportion: 50,
				parentColNumber: 12,
				tabColNumber: 4
			}}
			legend={legend}
		/>
	)


}
